export const GET_ROLES = gql`
    query GetRoles {
        roles {
            id
            name
            description
            hierarchyLevel
            createdAt
            updatedAt
            permissions {
                id
                addPartner
                viewPartner
                editPartner
                changePartnerStatus
                addMerchant
                addService
                viewMerchant
                editMerchant
                cancelServices
                changeMerchantStatus
                unmaskPll
                leadManagement
                pricingAndProductManagement
                reportingExcludingFinance
                reportingIncludingFinance
                stockManagement
                viewFinance
                viewCommissions
                viewSelfBillingInvoices
                addInvoice
                addPayment
                addCredit
                partnerShop
                serviceDesk
                configurationUserManagement
                configurationAuditLog
                configurationFinance
                configurationSage
                managePartnerResources
                configurationPartnerResources
                configurationOther
                customerSuccess
                deleteApplication
                accountStatements
            }
            users {
                id
                email
                username
                phoneNumber
                status
            }
        }
    }
`;

export const GET_ROLE = gql`
    query getRole($id: Int!) {
        role(id: $id) {
            id
            name
            description
            hierarchyLevel
            createdAt
            updatedAt
            permissions {
                id
                addPartner
                viewPartner
                editPartner
                changePartnerStatus
                addMerchant
                addService
                viewMerchant
                editMerchant
                cancelServices
                changeMerchantStatus
                unmaskPll
                leadManagement
                pricingAndProductManagement
                reportingExcludingFinance
                reportingIncludingFinance
                stockManagement
                viewFinance
                viewCommissions
                viewSelfBillingInvoices
                addInvoice
                addPayment
                addCredit
                partnerShop
                serviceDesk
                configurationUserManagement
                configurationAuditLog
                configurationFinance
                configurationSage
                managePartnerResources
                configurationPartnerResources
                configurationOther
                customerSuccess
                deleteApplication
                accountStatements
            }
            users {
                id
                email
            }
        }
    }
`;
